import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextInput, SelectInput, DateField, Checkbox, Modal } from '../index';
import './styles.css';
import kindbody from "../../assets/logos/kindbody.svg";

class SignUpForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false, 
    }
  }

  render() {
    const { fields , accountInfo, userInfo, errors } = this.props;
    if (!fields) {
      return null
    }

    let formFields = fields.map((field) => {
      let type
      let error = false
      if (errors.includes(field.field)) {
        error = true
      }

      switch (field.type) {
        case "select": 
          type = "userInfo"
          return (
            <SelectInput
              key={field.label}
              label={field.label}
              value={userInfo[field.field].value}
              type={type}
              handleSelect={this._handleInput.bind(this)}
              options={field.options} 
              field={field.field}
              error={error}
            />
          );
        case "date": 
          type = "userInfo"
          return (
            <DateField
              key={field.label}
              label={field.label}
              value={userInfo[field.field].value}
              onChange={this._handleInput.bind(this, type, field.field)}
              error={error}
              />
          );
          case "checkbox": 
            type = "accountInfo"
            return (
              <Checkbox 
                key={field.field}
                label={field.label}
                isChecked={accountInfo[field.field].value}
                onChange={this._handleInput.bind(this, type, field.field)}
                modal={this._handleModal.bind(this)}
              />
            )
        default: 
          accountInfo.hasOwnProperty(field.field) ? type = "accountInfo" : type = "userInfo";
          return (
            <TextInput
              key={field.label}
              name={field.label}
              label={field.label}
              value={type === "accountInfo" ? accountInfo[field.field].value : userInfo[field.field].value}
              onChange={this._handleInput.bind(this, type, field.field)}
              type={field.type}
              minLength={1}
              required={field.required}
              error={error}
              placeholder={field.placeholder || ""}
            />
          );
      }
    })

    let modalChildren = (
      <div className="modal__wrapper">
        <img 
          className="modal__logo" 
          src={kindbody} 
          alt="KindBody Logo"/>
        <h2 className="modal__title h2">Electronic Communications Consent</h2>
        <div className="modal__content type__body">
          <p>Providing us with authorization to email and text you will allow Kindbody to exchange information with you more efficiently and will benefit you as a member. At the same time, we recognize that email and text messaging are not a completely secure means of communication</p>
          <p>We have taken considerable effort to protect the personal health information of our members, and recommend that all members provide us with this authorization so that we can more efficiently communicate with them.</p>
          <p>We require this authorization to provide you with the best care and communications.</p>
        </div>
        <button className="modal__button button type__button" onClick={this._handleModalAgree.bind(this)}>I Agree</button>
        <button className="modal__button close button type__button" onClick={this._handleModal.bind(this)}>Close</button>
      </div>
    )

    return (
      <div className="sign-up-form-wrapper">
        {formFields}
        { this.state.modalOpen ? (
          <Modal 
            open={this.state.modalOpen}
            label=" Electronic Communications Consent"
            children={modalChildren}
          />
        ) : null}
      </div>
    )
  }

  // Custom --------------------------------------
  _handleInput(type, field, e) {
    let value
    if(typeof(e) === "object") {
      if(typeof(e.value) === "string") {
        value = e.value
      } else {
        e.target.type === "checkbox" ? value = e.target.checked : value = e.target.value
      }
    } else {
      value = e
    }
    this.props.handleInput(type, field, value)
  }

  _handleModal() {
    let isOpen = this.state.modalOpen
    this.setState({ modalOpen: !isOpen })
  }

  _handleModalAgree() {
    this._handleModal()
    this._handleInput("accountInfo", "communicationConsent", true);
  }
}


SignUpForm.propTypes = {
  fields: PropTypes.array.isRequired,
  handleInput: PropTypes.func.isRequired,
  accountInfo: PropTypes.object.isRequired, 
  userInfo: PropTypes.object.isRequired, 
  errors: PropTypes.array.isRequired
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/components/SignUpForm/SignUpForm.js